import { motion } from 'framer-motion'
import { Check, X } from 'lucide-react'

const ComparisonTable = () => {
  const features = [
    {
      name: 'Gestão de Alunos',
      aluno: true,
      escola: true,
      professor: true
    },
    {
      name: 'Avaliações',
      aluno: true,
      escola: true,
      professor: true
    },
    {
      name: 'Sistema de Troféus',
      aluno: true,
      escola: true,
      professor: false
    },
    {
      name: 'Pagamentos',
      aluno: true,
      escola: true,
      professor: false
    },
    {
      name: 'Relatórios Financeiros',
      aluno: false,
      escola: true,
      professor: false
    },
    {
      name: 'Gestão de Turmas',
      aluno: false,
      escola: true,
      professor: true
    },
    {
      name: 'Agenda',
      aluno: false,
      escola: true,
      professor: true
    },
    {
      name: 'Chat/Mensagens',
      aluno: true,
      escola: true,
      professor: true
    },
    {
      name: 'Indicadores e KPIs',
      aluno: false,
      escola: true,
      professor: false
    },
    {
      name: 'Avaliação da Escola',
      aluno: true,
      escola: false,
      professor: false
    }
  ]

  const apps = [
    {
      name: 'App do Aluno',
      color: 'from-blue-500 to-cyan-500',
      description: 'Para alunos acompanharem seu progresso'
    },
    {
      name: 'App da Escola',
      color: 'from-green-500 to-emerald-500',
      description: 'Para gestores administrarem a escola'
    },
    {
      name: 'App do Professor',
      color: 'from-purple-500 to-pink-500',
      description: 'Para professores gerenciarem avaliações e alunos'
    }
  ]

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl lg:text-4xl font-bold text-dark-900 mb-4">
            Comparativo de Funcionalidades
          </h2>
                      <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Veja quais funcionalidades estão disponíveis em cada app do nosso ecossistema.
            </p>
        </motion.div>

        <div className="overflow-x-auto">
          <div className="min-w-full bg-white rounded-2xl shadow-lg overflow-hidden">
            {/* Header */}
            <div className="bg-gray-50 border-b border-gray-200">
              <div className="grid grid-cols-4 gap-4 p-6">
                <div className="text-left">
                  <h3 className="text-lg font-semibold text-dark-900">Funcionalidade</h3>
                </div>
                {apps.map((app, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: index * 0.1 }}
                    className="text-center"
                  >
                    <div className={`inline-flex items-center justify-center w-12 h-12 rounded-xl bg-gradient-to-r ${app.color} text-white mb-3`}>
                      {index === 0 && '👤'}
                      {index === 1 && '🏫'}
                      {index === 2 && '👨‍🏫'}
                    </div>
                    <h3 className="text-lg font-semibold text-dark-900 mb-1">{app.name}</h3>
                    <p className="text-sm text-gray-600">{app.description}</p>
                  </motion.div>
                ))}
              </div>
            </div>

            {/* Features */}
            <div className="divide-y divide-gray-200">
              {features.map((feature, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: index * 0.05 }}
                  className="grid grid-cols-4 gap-4 p-6 hover:bg-gray-50 transition-colors"
                >
                  <div className="text-left">
                    <span className="text-gray-700 font-medium">{feature.name}</span>
                  </div>
                  
                  <div className="text-center">
                    {feature.aluno ? (
                      <Check className="h-6 w-6 text-green-500 mx-auto" />
                    ) : (
                      <X className="h-6 w-6 text-gray-300 mx-auto" />
                    )}
                  </div>
                  
                  <div className="text-center">
                    {feature.escola ? (
                      <Check className="h-6 w-6 text-green-500 mx-auto" />
                    ) : (
                      <X className="h-6 w-6 text-gray-300 mx-auto" />
                    )}
                  </div>
                  
                  <div className="text-center">
                    {feature.professor ? (
                      <Check className="h-6 w-6 text-green-500 mx-auto" />
                    ) : (
                      <X className="h-6 w-6 text-gray-300 mx-auto" />
                    )}
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>

        {/* Legend */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="mt-8 text-center"
        >
          <div className="inline-flex items-center space-x-6 text-sm text-gray-600">
            <div className="flex items-center space-x-2">
              <Check className="h-4 w-4 text-green-500" />
              <span>Disponível</span>
            </div>
            <div className="flex items-center space-x-2">
              <X className="h-4 w-4 text-gray-300" />
              <span>Não disponível</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  )
}

export default ComparisonTable
